<script lang="ts">
    import { hasKeysOfType, isNumber } from '@bayer-int/portletce-shared';
    import { select } from '@rxsv/core';

    import { getStoreContext } from 'portlet/common/contexts';
    import { Selectors } from 'portlet/store/index';
    import { AclibError } from 'portlet/common/errors';

    interface Props {
        error: AclibError;
    }

    let { error }: Props = $props();
    const store = getStoreContext();
    const customErrorMessages$ = store.state$.pipe(select(Selectors.customErrorMessagesSelector));

    const isWarning = error.severity === 'WARN';
    const httpStatus = hasKeysOfType(error.originalError, isNumber, 'status')
        ? error.originalError.status
        : null;
    const hasCustomError = !!($customErrorMessages$ && $customErrorMessages$[String(httpStatus)]);
    const errorTitleArray = hasCustomError
        ? $customErrorMessages$[String(httpStatus)].title.split('\n')
        : error.message.split('\n');
    const message = hasCustomError
        ? $customErrorMessages$[String(httpStatus)].message.split('\n')
        : error.details;
</script>

<div class="error-container" class:warning={isWarning}>
    {#each errorTitleArray as errorTitle}
        <p class="error-container__title">{errorTitle}</p>
    {/each}
    {#each message as detail}
        <p class="error-container__description">{detail}</p>
    {/each}
    {#if httpStatus}
        <p class="error-container__http-status">HTTP status: {httpStatus}</p>
    {/if}
</div>

<style lang="scss">
    .error-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding: 0 2rem 3rem 2rem;
        text-align: center;
        overflow-wrap: break-word;
        color: #dc3e35;

        &__title {
            margin: 0.3rem;
            font-size: 1.5em;
        }

        &__description {
            font-size: 1.1em;
            margin: 0.8em 0;
        }

        &__http-status {
            margin: 0;
            font-size: 0.8em;
        }
    }

    .warning {
        color: #efb92d;
    }
</style>
